<!--
Author: TangChen
Date: 2018-09-25
Desc: 设置组件内温馨提示，为公共组件
 -->
<template>
    <div v-if="hints.trim()!==''" class="comp-hint comp border-top">
        <div class="hint">
            <div class="icon">
                <i class="el-icon-warning" />温馨提示：
            </div>
            <div class="hint-list" v-html="hints" />
        </div>
    </div>
</template>
<script>
export default {
    name: "Hint",
    props: {
        hints: {
            type: String,
            required: true
        }
    },
    data () {
        return {};
    },
    mounted(){
        console.log(this.hints);
    },
    methods: {
    }
};
</script>
<style lang="scss">
@import '../../assets/css/varibles';
.comp-hint {
  .hint {
    padding-top: 10px;
    .icon {
      color: $color-a;
      line-height: 30px;
      i {
        margin-right: 3px;
      }
    }
    .hint-list {
      color: $text-color3;
      line-height: 18px;
      font-size: $f12;
    }
  }
}
</style>
